/* eslint max-len: 0 */

import React from 'react';
import styled from 'react-emotion';
import Footer from '../components/Footer';
import Container from '../components/Container';

import SlideUp from '../components/ani/SlideUp';
import Browser from '../util/Browser';

import EmailContact from '../components/EmailContact';
import ContactCards from '../components/ContactCards';
import ContactHeader from '../components/ContactHeader';

import FillBg from '../components/FillBg';
import LinePad from '../components/LinePad';

const Wrapper = styled.div`
  margin-top: -1rem;
  margin-bottom: 2rem;
`;

let SlideUp00 = styled.div``;

const Contact = () => {
  if (Browser() === 'chrome') {
    SlideUp00 = SlideUp;
  }
  return (
    <React.Fragment>
      <ContactHeader />
      <Container>
        <FillBg>
          <Wrapper>
            <ContactCards />
            <SlideUp00 fromY="0px" fromX="64px" delay={1400}>
              <LinePad
                style={{
                  marginBottom: '4rem',
                }}
              />
            </SlideUp00>
            <SlideUp00 delay={340}>
              <EmailContact />
            </SlideUp00>
          </Wrapper>
          <br />
        </FillBg>
      </Container>
      <Footer />
    </React.Fragment>
  );
};
export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx